export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21')
];

export const server_loads = [];

export const dictionary = {
		"/": [5],
		"/(admin)/agents": [6,[2]],
		"/(admin)/agents/[agent]": [7,[2,3]],
		"/(admin)/agents/[agent]/agent": [8,[2,3]],
		"/(admin)/agents/[agent]/manifesto": [9,[2,3]],
		"/(admin)/agents/[agent]/narratives": [10,[2,3]],
		"/(admin)/agents/[agent]/prompts": [11,[2,3]],
		"/(admin)/agents/[agent]/sources": [12,[2,3]],
		"/(admin)/agents/[agent]/training": [13,[2,3]],
		"/(admin)/dashboard": [14,[2]],
		"/(admin)/news": [15,[2,4]],
		"/(admin)/news/[agent]": [16,[2,4]],
		"/(admin)/news/[agent]/[id]": [17,[2,4]],
		"/(admin)/prompts": [18,[2]],
		"/(admin)/sources": [19,[2]],
		"/(admin)/stats": [20,[2]],
		"/(admin)/users": [21,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';